import React, { forwardRef, useState } from 'react';
import ErrorContainer from '../../ErrorContainer/ErrorContainer';
import {
  LabelContainer,
  LabelText,
  PrefixText,
  StyledInput,
  StyledLabel,
  TooltipContainer,
  TooltipText,
} from './NumericInput.styles';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/info.svg';

const NumericInput = forwardRef(
  (
    {
      defaultValue,
      value,
      placeholder,
      onChange,
      autoFocus,
      disabled,
      className,
      error,
      hideErrorMessage,
      type,
      step,
      label,
      prefix,
      tooltipText,
      smallError,
      ...inputProps
    },
    ref,
  ) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
      <StyledLabel disabled={disabled} className={className}>
        {label && (
          <LabelContainer>
            <LabelText>{label}</LabelText>
            {tooltipText && (
              <InfoIcon
                width={16}
                height={16}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              />
            )}
            {tooltipText && showTooltip && (
              <TooltipContainer>
                <TooltipText>{tooltipText}</TooltipText>
              </TooltipContainer>
            )}
          </LabelContainer>
        )}
        {prefix && <PrefixText>{prefix}</PrefixText>}
        <StyledInput
          ref={ref}
          placeholder={placeholder ? placeholder : '0.00'}
          type={type ? type : 'number'}
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          autoFocus={autoFocus}
          disabled={disabled}
          step={step ? step : 'any'}
          onWheel={e => e.target.blur()}
          $prefix={!!prefix}
          {...inputProps}
        />
        {!hideErrorMessage && <ErrorContainer small={smallError} errorText={error} />}
      </StyledLabel>
    );
  },
);

export default NumericInput;
